import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useModal } from "../../_contexts";
import { IconButton, Icon, Checkbox } from "../../_components";
import { ChronosDate } from "../../_helpers";

const TERTIARY_FALLBACK =
  "https://www.worldanvil.com/images/placeholder-orange.jpg";

export function EventListItem({
  event,
  onSelect,
  active,
  calendar,
  eraPrefixes,
}) {
  const { items: timelines } = useSelector((state) => state.timelines);
  const { items: images } = useSelector((state) => state.images);
  const { data: chronicle } = useSelector((state) => state.chronicle);

  const { openModal } = useModal();
  const handleSelectEvent = () => {
    onSelect(event._id);
  };

  const handleDeleteEvent = () => {
    openModal("confirmDelete", {
      prevModal: "eventManager",
      type: "event",
      item: { ...event },
    });
  };

  const handleEditEvent = () => {
    openModal("newEvent", {
      prevModal: "eventManager",
      eventItem: { ...event },
    });
  };

  const getCoverImageURL = () => {
    // return "https://www.gstatic.com/webp/gallery/4.sm.webp";
    let url = null;
    if (typeof event.cover === "string") {
      // console.log('event has cover! (string)', event.title);
      let image = images.find((i) => i._id === event.cover);
      if (image && image.url) {
        url = image.url;
      }
    } else if (event.cover?.url) {
      // console.log('event has cover! (object)', event.title);
      url = event.cover.url;
    } else if (chronicle && chronicle.defaultCover) {
      if (typeof chronicle.defaultCover === "string") {
        // console.log('event falling back to chronicle (string)', event.title);
        //Lookup
        let image = images.find((i) => i._id === chronicle.defaultCover);
        if (image && image.url) url = image.url;
      } else {
        // console.log('event falling back to chronicle (object)', event.title);
        url = chronicle.defaultCover?.url;
      }
    } else {
      // console.log('event falling back to TERTIARY', event.title);
      url = TERTIARY_FALLBACK;
    }
    if (url === null) url = TERTIARY_FALLBACK;
    return url.slice();
  };
  const timeline = event.timeline
    ? timelines.find((t) => t._id === event.timeline).title || ""
    : "";

  const imageURL = getCoverImageURL();
  const dateMask = "$DD$ $MMMM$, $YYYY$";

  const classNames = ["chronos-eventlist-item", "chronos-list-item"];
  if (active) {
    classNames.push("chronos-list-item-active");
  }

  const eraPrefixBefore = (eraPrefixes && eraPrefixes.before) || "BCE";
  const eraPrefixAfter = (eraPrefixes && eraPrefixes.after) || "CE";
  const isWebP = /.webp$/.test(imageURL);

  return (
    <li className={classNames.join(" ")}>
      <div className="chronos-list-item-select">
        <Checkbox value={active} custom onClick={handleSelectEvent} />
      </div>
      <div
        className="chronos-list-item-image"
        style={{
          backgroundImage: imageURL && !isWebP ? `url(${imageURL})` : "none",
        }}
      >
        {isWebP && (
          <img
            src={imageURL}
            alt={`${event.title}`}
            className="chronos-list-item-image-fallback"
          />
        )}
      </div>
      <div className="chronos-event-list-item-details">
        <div className="chronos-list-item-text">
          <h5 className="chronos-list-item-title">{event.title}</h5>
          <h6 className="chronos-event-dates">
            {event.fromDate && (
              <>
                <Icon icon="far fa-calendar fa-fw" />
                &nbsp;
                {new ChronosDate(event.fromDate, { calendar }).format(
                  dateMask,
                  undefined,
                  eraPrefixAfter,
                  eraPrefixBefore
                )}
              </>
            )}
            {event.toDate &&
              new ChronosDate(event.toDate, { calendar }).format(
                ` - ${dateMask}`,
                undefined,
                eraPrefixAfter,
                eraPrefixBefore
              )}
          </h6>
          <h6 className="chronos-event-timeline">
            {timeline && timeline.length > 0 && (
              <>
                <Icon icon="far fa-stream fa-fw" />
                &nbsp;
              </>
            )}
            {timeline}
          </h6>
          <p className="chronos-list-item-desc">
            {/* {event.excerpt || event.description} */}
          </p>
        </div>

        <div className="chronos-list-item-controls">
          <IconButton
            data-tip="Edit"
            icon="fas fa-pencil fa-fw"
            color="primary"
            onClick={handleEditEvent}
          />
          <IconButton
            data-tip="Delete"
            icon="fas fa-trash fa-fw"
            color="danger"
            onClick={handleDeleteEvent}
          />
        </div>
      </div>
    </li>
  );
}
